import { render } from "./checkboxes.vue?vue&type=template&id=4152116a"
import script from "./checkboxes.vue?vue&type=script&lang=js"
export * from "./checkboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__